import type { Product } from "../types/product";
import { ProductCard } from "./ProductCard";
import { motion } from "framer-motion";
import { FloatingArrowUp } from "./FloatingArrowUp";

interface ProductGridProps {
  products: Product[] | null;
  onAddToCart: (product: Product) => void;
}

export function ProductGrid({ products, onAddToCart }: ProductGridProps) {
  return (
    <>
      <motion.div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6"
        initial="hidden"
        animate="visible"
        variants={{
          visible: {
            transition: {
              staggerChildren: 0.1,
            },
          },
        }}
      >
        {products?.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            onAddToCart={onAddToCart}
          />
        ))}
      </motion.div>
      <FloatingArrowUp />
    </>
  );
}
